import { BarLoader } from "react-spinners";

const FullScreenLoadingSpinner = () => {
  return (
    <div className="absolute inset-0 flex flex-col flex-wrap justify-center place-items-center gap-4  z-50 bg-indigo-600">
      <div>
        <img
          className="mx-auto w-20 h-auto"
          src="/superset-icon-white.png"
          alt="Superset"
        />
        <h1 className="mb-1 mt-1 font-bold leading-7 text-white text-4xl tracking-tight">
          Superset
        </h1>
      </div>
      <BarLoader color="white" className="mb-12" />
    </div>
  );
};

export default FullScreenLoadingSpinner;
